import { render, staticRenderFns } from "./RequiredDocumentsList.vue?vue&type=template&id=7b2a6586&scoped=true"
import script from "./RequiredDocumentsList.vue?vue&type=script&lang=js"
export * from "./RequiredDocumentsList.vue?vue&type=script&lang=js"
import style0 from "./RequiredDocumentsList.vue?vue&type=style&index=0&id=7b2a6586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2a6586",
  null
  
)

export default component.exports